import { create } from 'zustand';

export const useInstitutionProposalTabsStore = create((set, get) => ({
    submitButtonLoading: false,
    submitButtonDisabled: false,
    onSubmitButtonClick: () => {},
    setSubmitButtonLoading: submitButtonLoading => set({ submitButtonLoading }),
    setSubmitButtonDisabled: submitButtonDisabled => set({ submitButtonDisabled }),
    setOnSubmitButtonClick: onSubmitButtonClick => set({ onSubmitButtonClick }),
}));
